import { useTranslation } from '@spcc/core'
import {
  Calendar,
  Package,
  CheckCircle,
  StatsWidget,
  StatsWidgetGrid,
  cn,
} from '@spcc/uikit'
import type { ShipmentsStatsProps } from '../types'

export function ShipmentsStats({
  stats,
  filterStatus,
  onStatusFilter,
}: ShipmentsStatsProps) {
  const { t } = useTranslation()

  return (
    <StatsWidgetGrid columns={3}>
      <StatsWidget
        label={t('shipments.scheduled')}
        value={stats.scheduled}
        icon={Calendar}
        color="slate"
        onClick={() => onStatusFilter('scheduled')}
        className={cn(filterStatus === 'scheduled' && 'ring-2 ring-slate-500')}
      />
      <StatsWidget
        label={t('shipments.loading')}
        value={stats.loading}
        icon={Package}
        color="amber"
        onClick={() => onStatusFilter('loading')}
        className={cn(filterStatus === 'loading' && 'ring-2 ring-amber-500')}
      />
      <StatsWidget
        label={t('shipments.delivered')}
        value={stats.delivered}
        icon={CheckCircle}
        color="emerald"
        onClick={() => onStatusFilter('delivered')}
        className={cn(filterStatus === 'delivered' && 'ring-2 ring-emerald-500')}
      />
    </StatsWidgetGrid>
  )
}
